export const TEXT_FIELDS = [
    {
        key: 'text.body.defaultSize',
        label: '본문 기본 글자 크기',
        help: '앱 본문 글자(BodyText) 중 화면이 크기를 따로 정하지 않은 글자의 크기입니다. 앱 전체의 많은 글자가 바뀌므로 주의해서 바꿉니다.',
        group: '본문',
        type: 'size',
        tokenGroup: 'fontSize',
        defaultValue: '$fontSize.sm',
        min: 10,
        max: 24,
    },
    {
        key: 'text.caption.size',
        label: '보조 글자 크기',
        help: '보조 글자(Caption — 토스트 문구, 사진 순번, 시각·조회 수 같은 작은 글자)의 크기입니다. 줄 높이는 크기의 1.4배입니다.',
        group: '보조 글자',
        type: 'enum',
        defaultValue: 'xs',
        options: [
            { value: '3xs', label: '3xs (10px)' },
            { value: '2xs', label: '2xs (11px)' },
            { value: 'xs', label: 'xs (12px)' },
            { value: 'xs-plus', label: 'xs-plus (13px)' },
            { value: 'sm', label: 'sm (14px)' },
        ],
    },
    {
        key: 'text.lineHeight.normal',
        label: '보통 줄 높이',
        help: '본문 글자와 제목(줄 높이를 따로 고르지 않은 제목)의 줄 높이를 글자 크기의 %로 정합니다. 140이면 14px 글자의 한 줄 높이가 20px(반올림)입니다.',
        group: '줄 높이',
        type: 'integer',
        defaultValue: 140,
        min: 100,
        max: 200,
        unit: '%',
    },
    {
        key: 'text.lineHeight.tight',
        label: '좁은 줄 높이',
        help: '"좁게"로 정한 제목의 줄 높이(글자 크기의 %)입니다.',
        group: '줄 높이',
        type: 'integer',
        defaultValue: 120,
        min: 100,
        max: 200,
        unit: '%',
    },
    {
        key: 'text.lineHeight.relaxed',
        label: '넓은 줄 높이',
        help: '"넓게"로 정한 제목의 줄 높이(글자 크기의 %)입니다.',
        group: '줄 높이',
        type: 'integer',
        defaultValue: 160,
        min: 100,
        max: 240,
        unit: '%',
    },
];
//# sourceMappingURL=text.js.map